import { LinearProgress, LinearProgressProps } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    progressContainer: {
        flexGrow: 1,
        alignSelf: 'center',
        borderRadius: 2,

        '& > div': {
            borderRadius: 2,
        },
    },
}));

export const PoolLinearProgress = (props: LinearProgressProps) => {
    const classes = useStyles();
    return (
        <div className={classes.progressContainer}>
            <LinearProgress {...props} />
        </div>
    );
};
